import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { portalApi, portalError } from "@/lib/weddingApi";
import { Loader2, Lock } from "lucide-react";

/** Exchanges the one-time secret in the URL fragment for a scoped session. */
export default function WeddingAccess() {
  const nav = useNavigate();
  const [error, setError] = useState("");
  const [manual, setManual] = useState("");
  const [busy, setBusy] = useState(true);

  const open = async (token) => {
    setBusy(true);
    setError("");
    try {
      const { data } = await portalApi.post("/session", { token });
      if (data?.session_token) sessionStorage.setItem("wedding_session", data.session_token);      window.history.replaceState(null, "", "/espace-reception/acces");
      nav("/espace-reception", { replace: true });
    } catch (e) {
      setError(portalError(e));
      setBusy(false);
    }
  };

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/token=([^&]+)/);
    if (match) open(decodeURIComponent(match[1]));
    else setBusy(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16">
      <div data-testid="wedding-access-card" className="w-full max-w-md bg-white border border-[#D9D3C5] p-8 md:p-10">
        <Lock size={20} className="text-[#B8956A]" />
        <h1 className="font-display text-3xl mt-5 font-light">Votre espace réception</h1>
        <p className="mt-3 text-sm text-[#697585]">
          Ouvrez le lien personnel reçu par email. Il est confidentiel et ne doit pas être transféré.
        </p>

        {busy && (
          <p data-testid="wedding-access-loading" className="mt-8 flex items-center gap-2 text-sm text-[#697585]">
            <Loader2 size={16} className="animate-spin" /> Ouverture de votre espace…
          </p>
        )}

        {!busy && (
          <div className="mt-8">
            <label className="overline">Code d'accès</label>
            <input
              data-testid="wedding-access-input"
              className="field mt-2 w-full"
              placeholder="Collez votre code ou le lien complet"
              value={manual}
              onChange={(e) => setManual(e.target.value)}
            />
            <button
              data-testid="wedding-access-submit"
              className="btn-primary mt-4 w-full"
              onClick={() => {
                const m = manual.match(/token=([^&\s]+)/);
                open(m ? decodeURIComponent(m[1]) : manual.trim());
              }}
            >
              Accéder à notre espace
            </button>
          </div>
        )}

        {error && (
          <p data-testid="wedding-access-error" className="mt-6 text-sm text-red-600 border-l-2 border-red-400 pl-3">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
